module.exports = __webpack_public_path__ + "img/banner-1.0f7a5896.jpg";